import { HttpParams } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { Filters } from '../../../mock-data/mock-filters';
import { ActiveFilter } from '../../../interfaces/active-filter';
import { forkJoin } from 'rxjs';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-reporting-map-detail',
  standalone: true,
  imports: [MatButtonModule],
  templateUrl: './reporting-map-detail.component.html',
  styleUrl: './reporting-map-detail.component.scss'
})
export class ReportingMapDetailComponent {
  name: string = "";
  count: string = "";
  iso: string = "";
  httpParams: HttpParams = new HttpParams();
  isNavigatingToList: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService
  ) { }
  onOpenTickets(): void {
  
      const filterDef = Filters.find((f) => f.db_key === "pct_countrycode");
      if (!filterDef) {
        console.warn(`No filter definition found for field: pct_countrycode`);
        return;
      }
      let countryFilters: ActiveFilter[] = []
      countryFilters.push({
        id: crypto.randomUUID(),
        key: filterDef,
        value: this.iso,
      });
  
      this.isNavigatingToList = true;
  
      forkJoin([
        this.userService.saveTableFilters('tCC', countryFilters),
        this.userService.saveTableFilters('pCC', countryFilters),
      ]).subscribe({
        next: () => {
          this.router.navigate(['/pTickets/list']);
        },
        error: (err) => {
          console.error('Failed to apply drill-down filters:', err);
          this.isNavigatingToList = false;
        },
      });
    }



}
